import { useQuery } from "@apollo/client";
import { CenterResult } from "__legacy/components/CenterResult";
import { CenterSpinner } from "__legacy/components/CenterSpinner";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import { StakeholdersQuery as StakeholdersQueryType, StakeholdersQueryVariables } from "./__generated__/StakeholdersQuery";

const StakeholdersQuery = loader("./StakeholdersQuery.gql");

type StakeholdersQueryProviderType = (props: {
  children: (data: StakeholdersQueryType) => ReactNode;
  variables: StakeholdersQueryVariables;
}) => ReactElement;

export const StakeholdersQueryProvider: StakeholdersQueryProviderType = (props) => {
  const { children, variables } = props;

  const { error, loading, data } = useQuery<StakeholdersQueryType, StakeholdersQueryVariables>(StakeholdersQuery, {
    variables,
    fetchPolicy: "cache-and-network",
  });

  if (loading) return <CenterSpinner size="large" />;
  if (error || !data)
    return <CenterResult status="404" title="404" subTitle="Sorry, the page you visited does not exist." />;

  return <Fragment>{children(data)}</Fragment>;
};
